import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
const Home = () => {
    const {
        HomeStore: { login },
    } = useStore();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const idno = searchParams.get('idno');
    const acc = searchParams.get('acc');
    const bid = searchParams.get('bid');
    const platform = searchParams.get('platform');
    const pid = searchParams.get('pid');
    const pname = searchParams.get('pname');
    const os = searchParams.get('os');
    const apver = searchParams.get('apver');
    const storever = searchParams.get('storever');
    const channel = searchParams.get('channel');
    const extra = searchParams.get('extra');
    const params = {
        idno,
        acc,
        bid,
        platform,
        pid,
        pname,
        os,
        apver,
        storever,
        channel,
        extra,
    };

    useEffect(() => {
        // (async () => {
        login(params);
        // })();
    }, []);
    return (
        <>
            {/* <div className="fade modal-backdrop show"></div>
            <div
                role="dialog"
                aria-modal="true"
                className="fade modal show"
                tabIndex="-1"
                style={{ display: 'block' }}
            >
                <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
                    <div className="modal-content">
                        <div className="text-center modal-header">
                            <div className="text-white w-100 modal-title h4">
                                【公告】目前線上不限用途款項借貸系統功能異常
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="border-0">
                                <div className="icon_fast mx-auto "></div>
                                <div className="icon_info mx-auto mb-3"></div>
                                <h3 className=" title fw-bolder text-center mt-3 lh-base">
                                    還款申請、增加擔保品、退還擔保品及相關查詢作業，緊急修復處理中，如需申請請洽所屬營業員或分公司協助辦理，
                                    造成不便敬請見諒。
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <form
                onSubmit={async e => {
                    e.preventDefault();
                    window.location.href = await login(params);
                    navigate('/loan', { replace: true });
                }}
            >
                <header className="header d-flex flex-wrap justify-content-between bg-white">
                    <div className="head-logo d-flex align-items-center">
                        <div className="logo">
                            <a
                                href="https://www.pscnet.com.tw/pscnetStock/index.do"
                                title="統一綜合證券"
                            />
                        </div>
                        <div className="logo2 position-relative ">
                            <Link
                                to="/"
                                title="統一綜合證券不限用途款項借貸"
                            ></Link>
                        </div>

                        {/* <button
                            type="button"
                            className="btn btn_check rounded-pill text-white text-center fs-12"
                            onClick={() => {
                                window.location.href =
                                    // 'https://10.107.4.227/?bid=5850&acc=5809891';
                                    'https://borrowwebuat.pscnet.com.tw/?bid=5850&acc=5809891';
                            }}
                        >
                            測試登入
                        </button> */}
                    </div>
                </header>

                <div className="herobanner">
                    <div className="row container pt-4 pb-sm-5 ">
                        <div className="ind-left col-md-5 mt-0  mt-sm-5 text-md-start text-center ps-md-0">
                            <div className="img_title mb-4 position-relative">
                                <span
                                    className="icon-fly d-none d-md-block wow rollIn"
                                    data-wow-delay="0.5s"
                                />
                            </div>
                            <h1 className="red fw-bolder mb-1">
                                不限用途款項借貸
                            </h1>
                            <h5>庫存股票變現金，資金運用好靈活</h5>
                            <Link to="/loan">
                                <button
                                    type="submit"
                                    className="ind-btn btn btn_check rounded-pill text-white mt-4 fs-5 px-5 py-2 position-relative d-none d-md-block"
                                    // onClick={() => {
                                    //     window.location.href =
                                    //         'http://localhost:3000/?idno=A123456789&platform=GPHONE&pid=PSC&pname=com.psc&os=11&apver=7.31.2.1355.PSC2A.2.987.PSC2A.R1&storever=G:PSC20221021181510&channel=mobile&bid=5850&acc=5809891&extra={%22multi_id%22:[{%22id%22:%22N123667158%22,%22pwd%22:%22e10adc3949ba59abbe56e057f20f883e%22,%22accounts%22:{%22STK%22:[%225850-5748509%22],%22FUT%22:[%225850-5748509%22],%22OSB%22:[%225850-00048185%22]}}]}';
                                    // }}
                                >
                                    立即申請
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={16}
                                        height={16}
                                        fill="currentColor"
                                        className="bi bi-chevron-right align-baseline position-absolute"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                        />
                                    </svg>
                                </button>
                            </Link>
                        </div>
                        <div className="ind-right col-md-7"> </div>
                    </div>
                </div>
                <div className="ind-listmenu text-white text-center py-5 ">
                    <div className=" row container wow fadeInDown">
                        <h2 className="d-none d-sm-block pb-4 mb-5">
                            額度循環動用小額借款不求人
                        </h2>
                        <div className="col mb-5 cur-pointer">
                            <Link to="/loan" className="text-white">
                                <i className="rounded-circle d-block m-auto mb-3" />
                                借款申請
                            </Link>
                        </div>
                        <div className="col mb-5 cur-pointer">
                            <Link to="/payoff" className="text-white">
                                <i className="rounded-circle d-block m-auto mb-3 " />
                                還款申請
                            </Link>
                        </div>
                        <div className="col mb-5 cur-pointer">
                            <Link to="/return" className="text-white">
                                <i className="rounded-circle d-block m-auto mb-3" />
                                退還擔保品
                            </Link>
                        </div>
                        <div className="col cur-pointer">
                            <Link to="accounting" className="text-white">
                                <i className="rounded-circle d-block m-auto mb-3" />
                                帳務查詢
                            </Link>
                        </div>
                        <div className="col cur-pointer">
                            <Link to="trialbalance" className="text-white">
                                <i className="rounded-circle d-block m-auto mb-3" />
                                借款維持率試算
                            </Link>
                        </div>
                    </div>
                </div>
                <footer className="footerbox-home text-center text-white my-0">
                    <div className="container">
                        <ul className="d-sm-flex justify-content-center ">
                            <li>總公司：台北市松山區東興路8號</li>
                            <li className="text-white">
                                <a
                                    href="tel:+886-2-81724668"
                                    className="text-white"
                                >
                                    電話：(02)8172-4668
                                </a>
                            </li>
                            <li>
                                <a
                                    href="mailto:info-center@uni-psg.com"
                                    className="text-white"
                                >
                                    服務信箱: info-center@uni-psg.com
                                </a>
                            </li>
                        </ul>
                        <p>
                            © 2023 President Securities Corporation All Rights
                            Reserved
                        </p>
                    </div>
                </footer>
            </form>
        </>
    );
};
export default observer(Home);
